// import {
//   PaymentElement,
//   LinkAuthenticationElement,
// } from "@stripe/react-stripe-js";
// import { useState } from "react";
// import { useStripe, useElements } from "@stripe/react-stripe-js";
// import Button from "../Buttons/Button";

// const CheckoutForm = () => {
//   const stripe = useStripe();
//   const elements = useElements();
//   const [message, setMessage] = useState(null);
//   const [isLoading, setIsLoading] = useState(false);

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!stripe || !elements) {
//       return;
//     }
//     setIsLoading(true);
//     const redirectURL =
//       localStorage.getItem("serviceType") === "HomeworkHelp"
//         ? `${window.location.origin}/dashboard/questions`
//         : `${window.location.origin}/dashboard/completion`;
//     const { error } = await stripe.confirmPayment({
//       elements,
//       confirmParams: {
//         return_url: redirectURL,
//       },
//     });
//     if (error.type === "card_error" || error.type === "validation_error") {
//       setMessage(error.message);
//     } else {
//       setMessage("An unexpected error occured.");
//     }

//     setIsLoading(false);
//   };


  

//   return (
//     <div>
//       <form
//         id="payment-form"
//         onSubmit={handleSubmit}
//       >
    
//         <LinkAuthenticationElement id="link-authentication-element" />
//         <PaymentElement id="payment-element" />
//         <Button
//           disabled={isLoading || !stripe || !elements}
//           id="submit"
//           className="mt-4"
//           text={!isLoading ? "Pay now" : "Payment in process ..."}
//         />
//         {message && <div id="payment-message">{message}</div>}
//       </form>
//     </div>
//   );
// };

// export default CheckoutForm;

import {
  PaymentElement,
  LinkAuthenticationElement,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";
import { useState, forwardRef, useImperativeHandle } from "react";

const CheckoutForm = forwardRef((props, ref) => {
  const stripe = useStripe();
  const elements = useElements();

  const [message, setMessage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async () => {
    if (!stripe || !elements) return;

    setIsLoading(true);

    const redirectURL =
      localStorage.getItem("serviceType") === "CourseHelp"
        ? `${window.location.origin}/dashboard/thank-you`
        : `${window.location.origin}/dashboard/completion`;

    const { error } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: redirectURL,
      },
    });

    if (error?.type === "card_error" || error?.type === "validation_error") {
      setMessage(error.message);
    } else if (error) {
      setMessage("An unexpected error occured.");
    }

    setIsLoading(false);
  };
  useImperativeHandle(ref, () => ({
    submitPayment: handleSubmit,
    isLoading,
  }));

  return (
    <>
      <LinkAuthenticationElement />
      <PaymentElement />
      {message && <div>{message}</div>}
    </>
  );
});

export default CheckoutForm;